const Contact = () => {
  return (
    <div>
      <h2>Contact Us</h2>
      <input placeholder="Your name" />
      <br />
      <textarea placeholder="Message" />
    </div>
  );
};

export default Contact;